module.exports = __webpack_public_path__ + "media/images/wedding/23-0a8a5628ca21aef552825d8bae5a94ea.jpg";